/* Protection Plan (/insurance) chooser -> add to cart.
   Renders the LOCKED #30 modal via the shared modal-core engine (modal-core.js: modalHTML,
   findVariant, selectChoice), then adds the right variant(s) via the AJAX Cart API.
   Config (permalinks + product ids) comes from data-* on #pp-modal. */
(function () {
  var modal = document.getElementById('pp-modal');
  var page = document.querySelector('.insurance-page');
  if (!modal || !page || typeof modalHTML !== 'function' || typeof findVariant !== 'function' || typeof selectChoice !== 'function') return;

  var mEl = document.getElementById('pp-m');
  var doneEl = document.getElementById('pp-done');
  var doneText = modal.querySelector('[data-pp-done-text]');
  var errEl = modal.querySelector('[data-pp-error]');

  var planBUrl = modal.getAttribute('data-plan-b-url') || '';
  var buySafeUrl = modal.getAttribute('data-buy-safe-url') || '';
  var safeProductId = parseInt(modal.getAttribute('data-safe-product-id') || '0', 10);
  var planAProductId = parseInt(modal.getAttribute('data-plan-a-product-id') || '0', 10);
  var apiRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var v = findVariant('30'); // LOCKED responsive modal: #27 rows on phones, #29 cards on iPad/desktop

  function itemsFromUrl(url) {
    var m = url.match(/\/cart\/([0-9:,]+)/);
    if (!m) return [];
    return m[1].split(',').map(function (pair) {
      var p = pair.split(':');
      return { id: parseInt(p[0], 10), quantity: parseInt(p[1] || '1', 10) };
    }).filter(function (it) { return it.id; });
  }
  function renderAsk() {
    mEl.className = 'm ' + (v.c || '');
    mEl.innerHTML = modalHTML(v);
    mEl.hidden = false;
    if (doneEl) doneEl.hidden = true;
    if (errEl) errEl.hidden = true;
  }
  function openModal() { renderAsk(); modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
  function closeModal() { modal.hidden = true; document.documentElement.style.overflow = ''; }

  // Delegate on document (always present) but only act on CTAs inside .insurance-page.
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('a.primary-button, a.text-chevron-link');
    if (!cta || !page.contains(cta) || modal.contains(cta)) return;
    e.preventDefault();
    openModal();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-pp-close]')) { closeModal(); return; }
    var choice = e.target.closest('#pp-m .c');
    if (choice) { selectChoice(choice); return; }
    var add = e.target.closest('#pp-m .next');
    if (add) { onAdd(add); return; }
  });

  // Count Safes and PLAN A (bought-with-a-Safe) in the cart. Plan B is ignored on purpose.
  function cartCounts(cb) {
    fetch(apiRoot + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var safes = 0, plans = 0;
        ((cart && cart.items) || []).forEach(function (it) {
          if (it.product_id === safeProductId) safes += it.quantity;
          else if (it.product_id === planAProductId) plans += it.quantity;
        });
        cb(safes, plans);
      })
      .catch(function () { cb(0, 0); });
  }
  function fail(btn) {
    if (errEl) { errEl.textContent = 'Sorry, we could not add that to your cart. Please try again.'; errEl.hidden = false; }
    if (btn) btn.disabled = false;
  }
  // Add items ONE AT A TIME, in array order, so the Safe lands before the plan (a single
  // multi-item add does not guarantee display order; the cart shows newest on top).
  function addToCart(items, choice, btn) {
    if (!items.length) { fail(btn); return; }
    if (errEl) errEl.hidden = true;
    if (btn) btn.disabled = true;
    var i = 0;
    (function step() {
      if (i >= items.length) {
        if (doneText) doneText.textContent = choice === 'buy'
          ? 'Your Space Safe and Protection Plan are in your cart.'
          : 'Your Protection Plan is in your cart.';
        mEl.hidden = true;
        if (doneEl) doneEl.hidden = false;
        if (btn) btn.disabled = false;
        return;
      }
      fetch(apiRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [items[i]] })
      }).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); i++; step(); })
        .catch(function () { fail(btn); });
    })();
  }
  function onAdd(btn) {
    // In modal-core's choices(), the BUY card ("I'm buying a Safe today") is DOM-first; OWN is second.
    var sel = mEl.querySelector('.c.sel'), first = mEl.querySelector('.cards .c');
    var isBuy = sel && sel === first;
    if (isBuy) {
      // Add Plan A always; add a Safe only when plans already meet-or-exceed safes (so plans
      // never outrun safes). Safe added LAST so it sits on top of the cart.
      btn.disabled = true;
      var buyItems = itemsFromUrl(buySafeUrl), safeItem = buyItems[0], planItem = buyItems[buyItems.length - 1];
      cartCounts(function (safes, plans) {
        var addSafe = plans >= safes;
        var list = addSafe ? [planItem, safeItem] : [planItem];
        addToCart(list, addSafe ? 'buy' : 'own', btn);
      });
    } else {
      addToCart(itemsFromUrl(planBUrl), 'own', btn);
    }
  }
})();
